// 营销/联盟渠道的追踪参数。
//
// 这些参数不改变页面内容,只是给投放系统做归因用。两处需要它:
//   1. 分页链接生成(category-pagination):不能把追踪参数透传到下一页,
//      否则 Googlebot 顺着分页一路爬下去,每一页都会派生出一个带参数的 URL 变体
//      —— GSC 里成百上千条 `p/6?srsltid=...`、`p/5?mc_cid=...` 就是这么滚出来的。
//   2. noindex 判定(middleware):带追踪参数的页面不该 noindex —— 分类页的
//      canonical 本来就指向不带 query 的干净路径,交给 canonical 收敛即可。
//      对它们打 noindex 反而会切断这批外链的权重传递。
export const TRACKING_PARAM_KEYS = new Set([
  // Google Ads / gtag
  'gclid',
  'gbraid',
  'wbraid',
  'gad_source',
  'gad_campaignid',
  'gclsrc',
  'gtm_latency',
  // Google Shopping 反馈参数
  'srsltid',
  // UTM 全家桶
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  // Mailchimp
  'mc_cid',
  'mc_eid',
  // CJ 联盟
  'cjevent',
  'cjdata',
  // Awin / ShareASale 联盟
  'awc',
  'sscid',
  'sv1',
  'sv_campaign_id',
  // Meta / 其他社交
  'fbclid',
  'ttclid',
  'msclkid',
  'igshid',
  // 站内网红/推广位
  'source',
  'code',
  // 历史遗留:AMP 与分页预取标记,同样不构成独立内容
  'amp',
  'pp',
]);

export const isTrackingParam = (key: string) => TRACKING_PARAM_KEYS.has(key);
